import { dateFormatDisplay } from '../../../Functions';

export function WBTruckHeadCompose(page, rowL, wbtr, data, dataUrl) {
    var doc = wbtr;
    var _y = rowL;
    var _space = page.spacingunit;
  
    _y = page.margin.top;
    var imageX = 145;
    doc.addImage(dataUrl, 'JPEG', imageX, page.headerFromTop, 55, 15);
    _y += _space * 2;

    doc.setFont("times", "bold");
    doc.text("Trucker's Waybill", 110, _y, null, null, "center");
    doc.setFont("times", "normal");
  
    _y += _space;
    doc.text(150, _y, "Control No. " + data.ctsNum);
  
    _y += _space * 2;
  
    return _y;
}

export function WBTruckBodyCompose(page, rowL, wbtr, data) {
    var doc = wbtr;
    var _y = rowL;
    var _space = page.spacingunit;
  
    // _y += _space * 2;
  
    doc.setFont("times", "bold");
    doc.text(10, _y, "Shipper");
    doc.setFont("times", "normal");
    doc.text(62, _y, data.shipperName ? data.shipperName : '');

    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, "Consignee");
    doc.setFont("times", "normal");
    doc.text(62, _y, data.consigneeName ? data.consigneeName : '');
   

    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, "Issuing Branch");
    doc.setFont("times", "normal");
    doc.text(62, _y, data.branch ? data.branch : '');

    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, "Voyage Sequence");
    doc.setFont("times", "normal");
    doc.text(62, _y, data.voyageNum ? data.voyageNum : '');

    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, "Vessel");
    doc.setFont("times", "normal");
    doc.text(62, _y, data.vessel ? data.vessel : '');

    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, "Voyage Reference");
    doc.setFont("times", "normal");
    doc.text(62, _y, data.voyageRef ? data.voyageRef : '');

    _y += _space * 2;
    doc.setFont("times", "bold");
    doc.text(10, _y, "Dispatch Type");
    doc.setFont("times", "normal");
    doc.text(62, _y, data.dispatchType ? data.dispatchType : '');
    
    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, "Pick-up/Delivery Addr.");
    doc.setFont("times", "normal");
    // doc.text(62, _y, data.address ? data.address : '');
    var address = doc.splitTextToSize(data.address ? data.address : '', 140);
    doc.text(62, _y, address);
    if (address.length > 1) {
        _y += ((_space * 0.5) * address.length)
    }

    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, "Dispatch Date");
    doc.setFont("times", "normal");
    doc.text(62, _y, data.dispatchDate ? data.dispatchDate : '');

    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, "Return Date");
    doc.setFont("times", "normal");

    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, "Truck No.");
    doc.setFont("times", "normal");
    doc.text(62, _y, data.truckerNum ? data.truckerNum : '');
    
    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, "Trailer No.");
    doc.setFont("times", "normal");
    doc.text(62, _y, data.trailerNum ? data.trailerNum : '');

    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, "Driver Name");
    doc.setFont("times", "normal");
    doc.text(62, _y, data.driverName ? data.driverName : '');

    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, "Helper Name");
    doc.setFont("times", "normal");
    doc.text(62, _y, data.helperName ? data.helperName : '');

    return _y;
}

export function WBTruckFootCompose(page, rowL, wbtr, data) {
    var doc = wbtr;
    var _y = rowL;
    var _space = page.spacingunit;
  
    _y += _space * 2;

    doc.setFont("times", "bold");
    doc.text(10, _y, "Waybill No.");
    doc.text(40, _y, "Container Van No.");
    doc.text(80, _y, "Seal No.");
    doc.text(105, _y, "Cargo Description");
    doc.text(145, _y, "Stuffing/Stripping");
    doc.text(190, _y, "Amount");
    doc.setFont("times", "normal");
    doc.line(10, _y + 1, 203, _y + 1);

    data.detail.forEach(d => {
        _y += _space;
        let stfstr = "";
        if(d.isStuffing && d.isStripping){
            stfstr = "Stuffing & Stripping";
        }
        else if(!d.isStuffing && d.isStripping){
            stfstr = "Stripping";
        }
        else if(d.isStuffing && !d.isStripping){
            stfstr = "Stuffing";
        }
        else {
            stfstr = "N/A";
        }
        let WB = d.wayBillRef ? d.wayBillRef : d.wayBIllRef ? d.wayBIllRef : "";
        doc.text(10, _y, WB);
        let container = d.vanNum ? d.vanNum : d.containerVanNum ? d.containerVanNum : d.containerVan ? d.containerVan : d.cts && d.cts.length > 0 ? d.cts[0].containerVanNum ? d.cts[0].containerVanNum : "" : "";
        doc.text(40, _y, container);
        let sealN = d.sealNum ? d.sealNum : d.cts && d.cts.length > 0 ? d.cts[0].containerVanNum ? d.cts[0].containerVanNum : "" : "";
        doc.text(80, _y, sealN);
       
        let commodity = d.goods ? d.goods === "goodOthers" ? d.goodOthers : d.goods : "";
        var splitGoods = doc.splitTextToSize(commodity, 40);
        doc.text(105, _y, splitGoods);
       
        doc.text(145, _y, stfstr);
        doc.text(190, _y, "PXXXXX");

        if (splitGoods.length > 1) {
            _y += (_space * splitGoods.length);
        }
    });

    _y += _space * 2;
    doc.setFont("times", "italic");
    doc.text("I have acknowledged that the above cargoes were recevied in good order and condition.", 105, _y, null, null, "center");
    doc.setFont("times", "normal");

    _y += _space * 2;
  
    doc.setFont("times", "bold");
    doc.text(30, _y, "Received By:");
    doc.setFont("times", "normal");
    doc.text(60, _y, "____________________________________");   
    doc.text(140, _y, "Date: ____________________");

    _y += _space;
    doc.text(70, _y, "Signature over Printed Name");

    _y += _space * 2;
    doc.setFont("times", "bold");
    doc.text(30, _y, "Prepared By:");
    doc.setFont("times", "normal");
    // doc.text(70, _y, data.user.name);
    doc.text(data.user.name.toUpperCase(), 95, _y, null, null, "center");
    doc.text(60, _y + 1, "____________________________________");   

    doc.text(140, _y, "Date: " + dateFormatDisplay(new Date()));

    _y += _space;
    doc.text(85, _y, "DAT Officer");

}